import { clearLocalStorageFilters } from './clear-local-storage-filters.utils';
import { clearAccessToken } from '@/utils/token.utils';

export const clearStorage = () => {
  clearAccessToken();
  localStorage.removeItem('status');
  localStorage.removeItem('componentKey');
  localStorage.removeItem('defectKey');
  sessionStorage.removeItem('role');
  clearLocalStorageFilters();
};

export const clearLocalCache = async () => {
  if ('caches' in window) {
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map((name) => caches.delete(name)));
  }
};
